import React, { ButtonHTMLAttributes } from 'react';
import { t } from 'ttag';
import styled from '@xstyled/styled-components';
import Icon from '~/assets/icons/settings-btn-eds.svg';
import { settingButtonAnimation } from '~/ui/animation';
import { EdsHudButton } from './EdsHudButton';

const StyledIcon = styled(Icon)`
  display: block;
  width: 20px;
  height: 20px;
  max-width: 100%;
  max-height: 100%;

  /* @media ((max-width: 580px) and (max-height: 300px)) {
    width: 16px;
    height: 16px;
  } */
`;

const Button = styled(EdsHudButton)`
  &:hover > svg {
    animation: ${settingButtonAnimation} 1s ease infinite;
  }
`;

export const SettingsButtonEds = React.forwardRef<
  HTMLButtonElement,
  ButtonHTMLAttributes<HTMLButtonElement>
>(
  (
    {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      children,
      ...props
    },
    ref
  ) => (
    <Button
      {...props}
      ref={ref}
      aria-label={t`Settings`}
      aria-haspopup="dialog"
    >
      <StyledIcon aria-hidden="true" focusable="false" />
    </Button>
  )
);

SettingsButtonEds.displayName = 'SettingsButtonEds';
